<template>
  <section name="home" :class="{'stats-open': selectedTrainingStats!=-1 }">
    <div class="home-section" :class="{'home-table-view': selectedView ==0}">
      <HeaderButtons
        :options="{
          showCreateBtn: showCreateBtn(), 
          loadingItem: addingTraining, 
          createBtnText: 'trainings.create_new',
          createItemAction: () => addNewTraining($store.state.currentGroupOpen),
          selectedTrainingStats: selectedTrainingStats,
          showBackBtn:true,
          selectedView: selectedView,
          type: 'edit',
          mode: 'edit'
        }"
        :addingTraining="addingTraining"
        @addNewTraining="addNewTraining"
        @selectView="selectedView=$event"
        @selectMode="selectedMode=$event"
        @goBack="goBack"
      />
      <TrainingTableView 
        v-show="selectedView==0"
        v-if="trainingGroup"
        :trainingGroup="trainingGroup"
        :selectedMode="selectedMode"
      />
      <span v-if="selectedView==1" class="folder-title" :class="{'not-editing':!editingTitle}" @click="startTitleEdit" v-click-outside-2="finishTitleEdit">
        <input ref="titleInput" v-if="editingTitle" type="text" v-model="trainingGroup.name" maxlength="255">
        <span v-else>{{trainingGroup.name}}</span>
        <svg v-if="hasPermission('trainings.edit_in_groups')" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.715908 15.984L4.43787 15.1501H4.46906C4.64378 15.1499 4.81675 15.1153 4.97804 15.0481C5.13933 14.9809 5.28577 14.8826 5.40898 14.7588L15.6028 4.56909C15.8547 4.31619 15.9961 3.97385 15.9961 3.61699C15.9961 3.26013 15.8547 2.9178 15.6028 2.66489L13.3352 0.392144C13.0822 0.140372 12.7397 -0.000976562 12.3827 -0.000976562C12.0257 -0.000976562 11.6832 0.140372 11.4302 0.392144L1.23033 10.5879C1.10538 10.7132 1.00727 10.8625 0.941957 11.027C0.876647 11.1914 0.845511 11.3673 0.850449 11.5442L0.0124846 15.2814C-0.0046463 15.3652 -0.0046463 15.4516 0.0124846 15.5354C0.0289097 15.6116 0.0603352 15.6838 0.104934 15.7477C0.149531 15.8116 0.20641 15.866 0.272253 15.9077C0.367145 15.9678 0.476979 16 0.589283 16.0008C0.63256 16.0016 0.675761 15.9968 0.717772 15.9864M12.021 0.983134C12.1169 0.887654 12.2468 0.834051 12.3822 0.834051C12.5176 0.834051 12.6475 0.887654 12.7435 0.983134L15.0116 3.25542C15.0597 3.30212 15.0979 3.35805 15.1239 3.41986C15.1499 3.48167 15.1632 3.54808 15.1629 3.61513C15.1628 3.68254 15.1494 3.74926 15.1234 3.81147C15.0974 3.87368 15.0594 3.93015 15.0116 3.97764L14.0288 4.95998L11.0354 1.96781L12.021 0.983134ZM2.09529 10.9048L10.4442 2.5574L13.4376 5.54958L5.08869 13.897L2.09529 10.9048ZM1.28619 13.4344L1.6805 11.6726L4.32847 14.3195L2.43467 14.742L1.28619 13.4344Z" fill="white"/>
        </svg>
      </span>
      <div
        :class="{
          'container wide--container main--container': true,
          'side--open': $store.getters.isSideOpen(),
          loaded: loaded,
        }"
        v-if="selectedView==1"
      >
        <div
          class="card-container"
          :class="{ flexStart: trainingGroup.trainings.length < 5 }"
          v-if="trainingGroup != ''"
        >
          <draggable
            class="inside-container"
            v-model="trainingGroup.trainings"
            animation="200"
            @end="onTrainingListChange(trainingGroup)"
          >
            <transition-group type="transition" class="centering" v-if="trainingGroup != undefined">
              <div
                v-for="(training, trainingIndex) in trainingGroup.trainings"
                :key="`training-${trainingGroup.id}-${trainingIndex}`"
                :class="[
                  'card',
                  $store.getters.hasPermission('training.*')
                    ? 'with--actions'
                    : '',
                ]"
              >
              <div class="tag-container">
                <span
                  v-if="$store.state.system_settings.isShop && !training.data.published"
                >
                  {{toLocal('home_edit.not_published')}}
                </span>
                 <span
                  class="attest-tag"
                  v-if="training.data && training.data.trainingType && training.data.trainingType == 'attest'"
                >
                  {{toLocal("training.attesting")}}
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.7769 7.3613C19.6301 7.01525 19.6092 6.48046 19.5987 5.96663C19.5672 5.02288 19.5253 3.96377 18.7807 3.21926C18.0362 2.47474 16.9771 2.44328 16.0334 2.40133C15.5091 2.38036 14.9743 2.35939 14.6387 2.22307C14.3241 2.09724 13.9466 1.74071 13.5796 1.39466C12.877 0.734032 12.0906 0 11 0C9.90944 0 9.12297 0.744519 8.4204 1.39466C8.05338 1.74071 7.67588 2.08675 7.3613 2.22307C7.01525 2.35939 6.48046 2.38036 5.96663 2.40133C5.02288 2.43279 3.96377 2.47474 3.21926 3.21926C2.47474 3.96377 2.44328 5.02288 2.40133 5.96663C2.38036 6.49094 2.35939 7.02574 2.22307 7.3613C2.09724 7.67588 1.74071 8.05338 1.39466 8.4204C0.734032 9.12297 0 9.90944 0 11C0 12.0906 0.744519 12.877 1.39466 13.5796C1.74071 13.9466 2.08675 14.3241 2.22307 14.6387C2.35939 14.9847 2.38036 15.5195 2.40133 16.0334C2.43279 16.9771 2.47474 18.0362 3.21926 18.7807C3.96377 19.5253 5.02288 19.5567 5.96663 19.5987C6.49094 19.6196 7.02574 19.6406 7.3613 19.7769C7.67588 19.9028 8.05338 20.2593 8.4204 20.6053C9.12297 21.266 9.90944 22 11 22C12.0906 22 12.877 21.2555 13.5796 20.6053C13.9466 20.2593 14.3241 19.9133 14.6387 19.7769C14.9847 19.6301 15.5195 19.6196 16.0334 19.5987C16.9771 19.5672 18.0362 19.5253 18.7807 18.7807C19.5253 18.0362 19.5567 16.9771 19.5987 16.0334C19.6196 15.5091 19.6406 14.9743 19.7769 14.6387C19.9028 14.3241 20.2593 13.9466 20.6053 13.5796C21.266 12.877 22 12.0906 22 11C22 9.90944 21.2555 9.12297 20.6053 8.4204C20.2593 8.05338 19.9028 7.67588 19.7769 7.3613ZM19.368 12.4156C18.9275 12.8875 18.4662 13.3804 18.2145 13.9781C17.9523 14.5968 17.9314 15.2888 17.8999 15.96C17.8789 16.6206 17.8475 17.3022 17.5748 17.5748C17.3022 17.8475 16.6206 17.8684 15.96 17.8999C15.2888 17.9209 14.5968 17.9523 13.9781 18.2145C13.3804 18.4662 12.8875 18.9275 12.4156 19.368C11.9228 19.8294 11.409 20.3117 10.9895 20.3117C10.5701 20.3117 10.0562 19.8294 9.56339 19.368C9.09152 18.9275 8.59867 18.4662 8.00095 18.2145C7.38227 17.9523 6.69018 17.9314 6.01907 17.8999C5.35844 17.8789 4.67684 17.8475 4.40419 17.5748C4.13155 17.3022 4.11058 16.6206 4.07912 15.96C4.05815 15.2888 4.02669 14.5968 3.76454 13.9781C3.51287 13.3804 3.05148 12.8875 2.61106 12.4156C2.14967 11.9228 1.6673 11.409 1.6673 10.9895C1.6673 10.5701 2.14967 10.0562 2.61106 9.56339C3.05148 9.09152 3.51287 8.59867 3.76454 8.00095C4.01621 7.38227 4.04766 6.69018 4.06864 6.01907C4.08961 5.35844 4.12107 4.67684 4.39371 4.40419C4.66635 4.13155 5.34795 4.11058 6.00858 4.07912C6.67969 4.05815 7.37178 4.02669 7.99047 3.76454C8.58818 3.51287 9.08103 3.05148 9.55291 2.61106C10.0458 2.14967 10.5596 1.6673 10.979 1.6673C11.3985 1.6673 11.9018 2.14967 12.4051 2.61106C12.877 3.05148 13.3699 3.51287 13.9676 3.76454C14.5863 4.02669 15.2784 4.04766 15.9495 4.07912C16.6101 4.1001 17.2917 4.13155 17.5643 4.40419C17.837 4.67684 17.858 5.35844 17.8789 6.01907C17.9104 6.69018 17.9314 7.38227 18.1935 8.00095C18.4452 8.59867 18.9066 9.09152 19.347 9.56339C19.8084 10.0562 20.2908 10.5701 20.2908 10.9895C20.2908 11.409 19.8294 11.9228 19.368 12.4156Z" fill="white"/>
                    <path d="M11 4.50879C7.4242 4.50879 4.51953 7.42395 4.51953 10.9892C4.51953 14.5545 7.43469 17.4697 11 17.4697C14.5653 17.4697 17.4804 14.5545 17.4804 10.9892C17.4804 7.42395 14.5863 4.50879 11 4.50879ZM11 15.7919C8.35747 15.7919 6.21829 13.6422 6.20781 10.9997C6.20781 8.35722 8.35747 6.20755 11 6.20755C13.6425 6.20755 15.7922 8.35722 15.7922 10.9997C15.7922 13.6422 13.6425 15.7814 11 15.7919Z" fill="white"/>
                    <path d="M12.8356 8.36805L9.67928 11.5139L8.82991 10.654C8.50483 10.3395 7.94907 10.3395 7.63448 10.654C7.4667 10.8113 7.38281 11.0315 7.38281 11.2517C7.38281 11.472 7.4667 11.6817 7.62399 11.839L9.08157 13.2966C9.23887 13.4538 9.4381 13.5482 9.6688 13.5482C9.8995 13.5482 10.1092 13.4538 10.277 13.2966L14.0206 9.55299C14.1779 9.39569 14.2722 9.17549 14.2722 8.95528C14.2722 8.73507 14.1779 8.51486 14.0206 8.35756C13.706 8.04298 13.1397 8.03249 12.8251 8.35756L12.8356 8.36805Z" fill="white"/>
                  </svg>
                </span>
                <span
                  v-if="$store.state.system_settings.isShop && training.data.paid"
                  class="selling-tag"
                >
                  {{toLocal('home_edit.selling')}}
                </span>
            </div>
                <div class="over-cover" v-if="training.enabled == 0">
                  <span class="disabled-tag">{{
                    toLocal("generic.disabled")
                  }}</span>
                  <!-- <TrainingEyeSvg /> -->
                </div>
                <div
                  class="cover"
                  :style="[
                    training.data.cover != ''
                      ? {
                          'background-image': `url('${getFileUrl(
                            training.data.cover
                          )}')`,
                        }
                      : {},
                  ]"
                  @click="training.data.trainingType =='attest' ? openTraining(training.id, training) :  editTraining(training.id, null, training.created_by)"
                >
                  <div class="play-button" v-if="training.enabled != 0">
                    <!-- <TrainingEyeSvg /> -->
                  </div>
                  <div class="title">
                    <span class="card-title">{{ training.data.title }}</span>
                    <div class="slider">
                      <span v-if="training.data.time != 0" class="slider--time">
                        {{ getTrainingTime(training.data.time) }}
                      </span>
                      <div class="slider--bar">
                        <div class="slider--fill" style="width: 0%" />
                        <div class="slider--blob" />
                      </div>
                    </div>
                  </div>
                </div>
                      <div
                  class="option-dots"
                  v-if="training.id != -1"
                  @click.stop="
                    activeOptionMenu == training.id
                      ? closeMenus()
                      : activeOptionMenu == -50
                      ? (activeOptionMenu = training.id)
                      : (activeOptionMenu = -50)
                  "
                >
                  <OptionDotsSvg class="themable"/>
                </div>
                <div
                  class="option-menu"
                  v-click-outside-2="closeMenus"
                  v-if="
                    ($store.state.user_role == 'admin' || hasPermission('users.assign_trainings') || hasPermission('trainings.edit') || hasPermission('users.view_stats')) &&
                    activeOptionMenu == training.id"
                >
                  <div class="color option-block" @click.stop="training.data.trainingType !='attest' ? openTraining(training.id, training) :  editTraining(training.id, null, training.created_by)">
                    <HomeEditEditTrainingSvg v-if="training.data.trainingType =='attest'" class="stroke" />
                    <svg v-else width="30" height="16" viewBox="0 0 30 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M28 8.00205C26.448 10.1736 24.4303 11.9373 22.1079 13.1523C19.7855 14.3673 17.2226 15 14.6238 15C12.0251 15 9.46252 14.3673 7.14014 13.1523C4.81777 11.9373 2.80006 10.1736 1.24805 8.00205C2.79935 5.82939 4.8165 4.06471 7.13897 2.84896C9.46143 1.6332 12.0247 1 14.6238 1C17.223 1 19.7862 1.6332 22.1087 2.84896C24.4312 4.06471 26.4487 5.82939 28 8.00205Z" stroke="#707070" stroke-width="2" stroke-miterlimit="10"/>
                      <path d="M14.624 12.5807C17.0521 12.5807 19.0205 10.5301 19.0205 8.00039C19.0205 5.47074 17.0521 3.42004 14.624 3.42004C12.1959 3.42004 10.2275 5.47074 10.2275 8.00039C10.2275 10.5301 12.1959 12.5807 14.624 12.5807Z" stroke="#707070" stroke-width="2" stroke-miterlimit="10"/>
                    </svg>
                  </div>
                  <div class="pencil option-block" @click.stop="openGroupSide(training)" v-if="($store.state.user_role == 'admin' || hasPermission('users.assign_trainings')) && (training && training.data ? training.data.trainingType != 'attest' : true)">
                    <HomeEditOpenGroupSvg class="stroke" />
                  </div>
                  <div class="trash option-block" @click.stop="trainingStats(training, training.id, training.rented)" v-if="$store.state.user_role == 'admin' || hasPermission('users.view_stats')">
                    <HomeEditStatsSvg class="stroke fill-gray" />
                  </div>
                  <div class="option-block" @click.stop="deleteTraining(training.id)" v-if="showDeleteButton(training)">
                    <HomeEditDeleteTrainingSvg class="stroke smaller" />
                  </div>
                </div>
         
                <div
                  v-if="!$store.getters.hasPermission('training.*')"
                  class="description"
                >
                  {{ training.data.description }}
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
    </div>
    <GlobalModal
      v-if="deletingTraining"
      :modalInfo="{
        type: 'confirmation',
        text: 'training_edit.delete_confirm',
        undertext: '',
        confirmBtnText: 'delete_modal.yes_delete',
        class:'delete'
      }"
      @onConfirm="deleteTrainingRequest"
      @onClose="deletingTraining = false"
    />
    <AssignModal
      v-if="selectedTraining"
      v-scroll-lock="selectedTraining"
      type="training"
      :item="selectedTraining"
      @modalClose="selectedTraining=null"
    />
    <TrainingStats 
      v-if="selectedTrainingStats!=-1" 
      v-scroll-lock="selectedTrainingStats!=-1" 
      :selectedTraining="selectedTrainingStats"
      :item="selectedTrainingItem"
      @goBack="selectedTrainingStats=-1"
    />
    <HomeTrainingOverlay v-if="overlay.open" :data="overlay.data" @close="overlay.open=false"/>
  </section>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import VueScrollTo from "vue-scrollto";
import TrainingGroupsSide from "../components/layout/trainings/TrainingGroupsSide";
import TrainingTableView from "../components/layout/trainings/TrainingTableView";
import TrainingStats from "@/views/TrainingStats";
import HomeTrainingOverlay from "@/components/layout/trainings/overlay/HomeTrainingOverlay.vue";

import _ from "lodash";
import { ObserveVisibility } from "vue-observe-visibility";
import GlobalModal from "@/components/layout/modals/GlobalModal.vue";
import AssignModal from "@/components/layout/modals/AssignModal.vue";
import TrainingSearch from "@/components/layout/TrainingSearch.vue";
import HeaderButtons from "@/components/layout/HeaderButtons.vue";


//SVG
import HomeEditSearchSvg from "@/assets/images/icons/homeEdit/home-edit-search.svg?inline";
import HomeEditSearchCancelSvg from "@/assets/images/icons/homeEdit/home-edit-search-cancel.svg?inline";
import HomeEditAddSvg from "@/assets/images/icons/homeEdit/home-edit-add.svg?inline";
import HomeEditDeleteSvg from "@/assets/images/icons/homeEdit/home-delete-widthless.svg?inline";
import HomeEditArrowDownSvg from "@/assets/images/icons/homeEdit/home-edit-arrow-down.svg?inline";
import HomeEditArrowUpSvg from "@/assets/images/icons/homeEdit/home-edit-arrow-up.svg?inline";
import HomeEditPlaySvg from "@/assets/images/icons/homeEdit/home-edit-play.svg?inline";
import HomeEditEditTrainingSvg from "@/assets/images/icons/homeEdit/home-edit-widthless.svg?inline";
import HomeEditOpenGroupSvg from "@/assets/images/icons/homeEdit/home-edit-group-widthless.svg?inline";
import HomeEditStatsSvg from "@/assets/images/icons/homeEdit/home-edit-stats-widthless.svg?inline";
import HomeEditDeleteTrainingSvg from "@/assets/images/icons/homeEdit/home-delete-widthless.svg?inline";
import PlusNarrowSvg from "@/assets/images/icons/plus-narrow-white.svg?inline";
import GroupSearchSvg from "@/assets/images/icons/group-search-black.svg?inline";
import LoadingBubbleSvg from "@/assets/images/icons/loading-bubble.svg?inline";
import ArrowLeftSvg from "@/assets/images/icons/homeEdit/arrow-go-back-16-8.svg?inline";
import TrainingDisabledSvg from "@/assets/images/icons/training-edit/training_disabled.svg?inline";
import TrainingEyeSvg from "@/assets/images/icons/training-edit/training_eye.svg?inline";
import OptionDotsSvg from "@/assets/images/icons/option-dots-edit.svg?inline";
import M from "minimatch";

export default {
  name: "HomeEdit",
  components: {
    OptionDotsSvg,
    draggable,
    TrainingGroupsSide,
    TrainingStats,
    GlobalModal,
    AssignModal,
    TrainingSearch,
    HeaderButtons,
    TrainingTableView,
    HomeTrainingOverlay,
    //SVG COMPONENTS
    HomeEditSearchSvg,
    HomeEditSearchCancelSvg,
    HomeEditAddSvg,
    HomeEditDeleteSvg,
    HomeEditArrowDownSvg,
    HomeEditArrowUpSvg,
    HomeEditPlaySvg,
    HomeEditEditTrainingSvg,
    HomeEditOpenGroupSvg,
    HomeEditStatsSvg,
    HomeEditDeleteTrainingSvg,
    PlusNarrowSvg,
    GroupSearchSvg,
    LoadingBubbleSvg,
    ArrowLeftSvg,
    TrainingDisabledSvg,
    TrainingEyeSvg,
  },
 
  directives: {
    "click-outside-editing-title": {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
            let index = vnode.data.ref.split("-")[1];
            vnode.context.setGroupTitle(index, vnode.elm.value);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
    ObserveVisibility,
  },

  data: function () {
    return {
      addingTraining: false,
      addingNewGroup: false,
      trainingGroup: "",
      trainings: [],
      loaded: false,
      selectedTraining: null,
      isSearching: false,
      searchInputValue: "",
      isHeaderInView: true,
      searchTerm: "",
      selectedTrainingStats: -1,
      selectedTrainingItem: null,
      activeOptionMenu: -50,
      deletingTraining: false,
      deletingTrainingID: -1,
      assignModalOpen:false,
      editingTitle:false,
      selectedView: 1,
      tableTrainings: [],
      loadedTableTrainings: false,
      selectedMode: 1,
      overlay: {
        open: false,
        data: {
          
        }
      }
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if(this.$route.query.editTitle && this.$route.query.editTitle == 1){
      this.startTitleEdit()
    }
    this.loadEditPage();
  },
  beforeDestroy() {
    this.loaded = false;
    this.searchInputValue = "";
    this.$store.state.homePageSearchInput = "";
    this.$store.state.homePageSearchLoaded = false;
    this.$store.state.showHomePageSearchInput = true;
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    activeOptionMenu(newVal){
    },
   
    searchInputValue(newVal) {
      if (newVal == "") this.isSearching = false;
      else if (newVal.length > 0 && !this.isSearching) this.isSearching = true;
    },
    "$store.state.homePageSearchInput"(newVal) {
      this.searchTrainingsInput();
      if (newVal == "") this.isSearching = false;
      else if (newVal.length > 0 && !this.isSearching) this.isSearching = true;
    },
    loaded() {
      this.$store.state.homePageSearchLoaded = this.loaded;
    },
    '$route.query.id':{
      handler(){
        this.loadEditPage();
      }
    }
  },
  methods: {
    startTitleEdit() {
      if(!this.hasPermission('trainings.edit_in_groups') && (this.trainingGroup.created_by != this.$store.state.user_id)) return
      this.editingTitle = true;
      this.$nextTick(()=>{
        let ref = this.$refs.titleInput;
        if(Array.isArray(ref)) ref = ref[0];
        ref.focus();
      })
    },
   
    finishTitleEdit() {
      if(!this.hasPermission('trainings.edit_in_groups') && (this.trainingGroup.created_by != this.$store.state.user_id)) return
      
      if( this.editingTitle)
        this.saveGroupInfo();
      this.editingTitle = false;
    },
    showDeleteButton(training) {
      if (this.$store.state.user_role == 'admin') return true;
      let show = false;
      let edit_permission = this.hasPermission('trainings.edit');
      if (edit_permission) {
       
        if (this.hasPermission('trainings.edit_own')) {
          let created_by = training.created_by;
          if (created_by == this.$store.state.user_id) {
            show = true;
          }
        }
        else show = true;
        if (this.$store.state.user_permissions['trainings.edit_in_groups']) {
          let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
          if (ids.includes(this.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
            show = true;
          }
          else show = false;
        }
      }
      else {
        show = false;
      }
      return show;
      
    },
    saveGroupInfo(){
      axios
        .post(
          `${this.$store.state.api_link}/training_group/editInfo/${this.trainingGroup.id}`,
          {
            name: this.trainingGroup.name,
          },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
        })
        .catch((error) => {
          this.$store.commit("handleError", { error: error });
        });
    },
    loadEditPage(){
       this.$store.state.loading.loadingStart();
      this.loaded = false;
      if(this.$route.query.id){
        this.$store.state.currentGroupOpen = this.$route.query.id 
      }
      setTimeout(() => {
        this.loadTrainings();
      }, 10);
      if(this.$store.state.currentTraining != -1){
        this.$store.state.currentTraining = -1;
      }
    },
    closeMenus() {
      setTimeout(() => {
        if (this.activeOptionMenu != -50) {
          this.activeOptionMenu = -50;
        }
      }, 200);
    },
    goBack() {
        this.$router.push("/edit");
    },
    handleScroll() {
      if (this.$refs["headerbuttons"] != undefined) {
        if (this.$refs["headerbuttons"].getBoundingClientRect().top >= 100) {
          this.isHeaderInView = true;
        } else {
          this.isHeaderInView = false;
        }
      }
    },
    loadTrainings() {
      let id = this.$store.state.currentGroupOpen;
      axios
        .get(
          `${this.$store.state.api_link}/training_group/training_groups_edit/${id}`,
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          let temp = response.data;
          if (temp[0] == undefined) {
            this.$store.state.loading.loadingDone();
            return;
          } else if (temp[0] != undefined) {
            temp.forEach((trainingGroup) => {
              trainingGroup["editingTitle"] = false;
        
              trainingGroup.trainings.forEach((training) => {
                training.data = JSON.parse(training.data);
              });
              trainingGroup.trainings.sort((a, b) => {
                if (a.weight < b.weight) return -1;
                else if (a.weight > b.weight) return 1;
                else return 0;
              });
              this.addingTraining = false;
              this.addingNewGroup = false;
              setTimeout(() => {
                this.loaded = true;
              }, 20);
    
            });
            this.trainingGroup = temp[0];
            this.trainings = temp[0].trainings;
            this.trainingsClone = _.cloneDeep(temp[0].trainings);
            VueScrollTo.scrollTo(`body`, 100);
            this.$store.state.loading.loadingDone();
          }
        })
        .catch((error) => {
          this.$store.commit("handleError", { error: error });
        });
    },
    loadTraining(id) {
      return axios
          .get(
            `${this.$store.state.api_link}/training/info/${id}?edit=true`,
            this.$store.getters.axiosConfig()
          );
    },
    openTraining(id, training) {
      this.$store.state.loading.loadingStart();

      if (training && training.data && ['scorm','singleDoc'].includes(training.data.trainingType)) {
          this.$store.state.currentTraining = id;
         this.loadTraining(id).then((response) => {
          let data = JSON.parse(response.data.data);
          let index = [0, 0];
           let item = null
           if (training.data.trainingType == 'scorm') {

             index[0] = data.content.findIndex(el => {
               index[1] = el.items.findIndex(item => item.type == 'scorm')
               if (index[1] != -1) {
                 item = el.items[index[1]];
               }
               return index[1] != -1
             })
             if (item) {
               this.overlay.data.item = item;
               this.overlay.data.training = this.$store.state.currentTraining;
             }
           }
           else if (training.data.trainingType == 'singleDoc') {
            item = data.content[0].items[0];
            if (item) {
              this.overlay.data.item = item;
              this.overlay.data.training = data;
            }
           }

          this.overlay.open = true;

          this.$store.state.loading.loadingDone();
        });
      }
      else {

        this.$store.state.previewMode = true;
        this.$store.state.currentTraining = id;
        this.$store.state.currentTrainingData = training;
        this.$store.state.previewTopic = -1;
        this.$router.push("/training?id=" + id);
      }
    },
    editTraining(id, query = null, created_by = null) {
      if(this.$store.state.user_role == 'admin' || this.hasPermission('trainings.edit')){
        this.$store.state.loading.loadingStart();
        this.$store.state.currentTraining = id;
        this.$store.state.previewTopic = -1;
        if (this.$store.state.user_role == 'admin') {
           if(query){
              this.$router.push("/edit-training?id=" + id+query);
            }
            else{
              this.$router.push("/edit-training?id=" + id);
          }
          return;
        }
        if (this.hasPermission('trainings.edit_own')) {
          let training = this.trainings.findIndex((t) => t.id == id);

          if (training != -1) {
            if (created_by != this.$store.state.user_id) {
              this.$router.push("/training?id=" + id);
            }
            else {
              if(query){
                this.$router.push("/edit-training?id=" + id+query);
              }
              else{
                this.$router.push("/edit-training?id=" + id);
              }
            }
          }
          else if(created_by && (created_by == this.$store.state.user_id)){
            this.$router.push("/edit-training?id=" + id);
          }
        }
        else if (this.$store.state.user_permissions['trainings.edit_in_groups']) {
          let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
          if (ids.includes(this.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
            if(query){
              this.$router.push("/edit-training?id=" + id+query);
            }
            else{
              this.$router.push("/edit-training?id=" + id);
            }
          }
          else {
            this.$router.push("/training?id=" + id);
          }
        }
        else {
          if(query){
            this.$router.push("/edit-training?id=" + id+query);
          }
          else{
            this.$router.push("/edit-training?id=" + id);
          }
          
        }
      }
      else {
        this.$router.push("/training?id=" + id);
      }
    },
    trainingStats(training, id, rentedStatus) {
      if(rentedStatus == 1){
        this.$store.state.currentTrainingRented = true;
      }else{
        this.$store.state.currentTrainingRented = false;
      }
      this.$store.state.loading.loadingStart();
      this.$store.state.currentTraining = id;
      this.selectedTrainingStats = id
      this.selectedTrainingItem = training;
      // this.$router.push("/training-stats");
    },
    addNewTraining(group) {
      this.addingTraining = true;
      axios
        .post(
          `${this.$store.state.api_link}/training/add`,
          { training_group: group },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          this.loadTrainings();
          let query = '&editTitle=1'
          this.$nextTick(() => {
            if(response.data.created_by)
              this.editTraining(response.data.training, query, response.data.created_by);
            else this.editTraining(response.data.training, query);
          })
        })
        .catch((error) => {
          this.$store.commit("handleError", { error: error });
        });
    },
    deleteTraining(id){
      this.deletingTrainingID = id;
      this.deletingTraining = true;
    },
    deleteTrainingRequest() {
      // if (!confirm(this.$store.getters.__("training_edit.delete_confirm")))
      //   return;

      this.addingTraining = true;
      axios
        .post(
          `${this.$store.state.api_link}/training/delete`,
          { id: this.deletingTrainingID },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          this.deletingTraining = false;
          this.deletingTrainingID = -1;
          this.loadTrainings();
        })
        .catch((error) => {
          this.deletingTraining = false;
          this.deletingTrainingID = -1;
          this.$store.commit("handleError", { error: error });
        });
    },
    openGroupSide(training) {
      this.selectedTraining = training;
      this.$store.commit("openSide", {
        side: "training-groups-side",
        sideInfo: { id: training.id },
      });
    },
    onTrainingListChange(group) {
      setTimeout(() => {
        let updatedWeightSearch = [];
        let updatedWeight = [];
        let weight = 1;
        group.trainings.forEach((training, index) => {
          updatedWeightSearch.push({ [training.id]: index + 1 });
        });
        group.trainings.forEach((training, index) => {
          updatedWeight.push({ [training.id]: index + 1 });
        });
        axios
          .post(
            `${this.$store.state.api_link}/training/set-training-weight`,
            { trainings: JSON.stringify(updatedWeightSearch) },
            this.$store.getters.axiosConfig()
          )
          .then((response) => {
            // this.loadTrainings();
          })
          .catch((error) => {
            this.$store.commit("handleError", { error: error });
          });
      }, 10);
    },
    searchTrainingsInput(event) {
      this.searchTrainings(event, this);
    },
    searchTrainings: _.debounce((event, self) => {
      // let text = self.$store.state.homePageSearchInput;
      if (self.searchTerm != "") {
        self.trainingGroup.trainings = self.trainingsClone.filter(
          (training) =>
            training.data &&
            training.data.title &&
            training.data.title != null &&
            training.data.title
              .toLowerCase()
              .includes(self.searchTerm.toLowerCase())
        );
      } else {
        self.trainingGroup.trainings = self.trainingsClone;
      }
    }, 10),

    setGroupOrder(groups, id, up) {
      var canOrder = false;
      groups = groups.filter(function (element) {
        return element !== undefined;
      });
      if (up) {
        if (id != 0) {
          this.swapElement(groups, id, id - 1);
          id = id - 1;
          canOrder = true;
        }
      } else {
        if (groups.length - 1 != id) {
          this.swapElement(groups, id, id + 1);
          id = id + 1;
          canOrder = true;
        }
      }
      if (canOrder) {
        axios
          .post(
            `${this.$store.state.api_link}/training_group/set-order`,
            { training_groups: [this.trainingGroup] },
            this.$store.getters.axiosConfig()
          )
          .then((response) => {})
          .catch(() => {});
      }
    },
    swapElement(array, indexA, indexB) {
      var tmp = array[indexA];
      array[indexA] = array[indexB];
      array[indexB] = tmp;
    },
    searchVisibilityChanged(e) {
      if (this.$store.state.homePageSearchLoaded)
        this.$store.state.showHomePageSearchInput = e;
    },
    getTrainingTime(time){
      let minutes = time;
      let hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      return  hours > 0 ? hours + ' val. '+minutes+' min.' : minutes+' min.'
    },
    showCreateBtn() {
      if (this.$store.state.user_role == 'admin') return true;
      if (this.hasPermission('trainings.create')) {
        if (this.$store.state.user_permissions['trainings.edit_in_groups']) {
          let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
          if (ids.includes(this.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
            return true;
          }
          else return false;
        }
        else {
          return true;
        }
      }
      return false
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/views/_homeEditViewScoped.scss";
.stats-open{
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.home-section{
  &.home-table-view{
    overflow-y: hidden;
    width: initial;
    padding-left: 2rem;
    .button-container{
      width: 100%;
      padding-right: 2rem;
    }
  }
}
.tag-container {
  position: absolute;
  top: 16px;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  span {
    position: relative;
    padding: 8px 12px 7px 16px;
    background: var(--secondary-color);
    color: var(--primary-color);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
    border-radius: 0px 20px 20px 0px;
    top: initial;
    line-height: 24px;
    font-size: 16px;
    width: fit-content;
    &.white {
      display: flex;
      align-items: center;
      svg {
        margin-left: 11px;
      }
      background: white;
    }
  }
  .selling-tag{
    background: var(--third-color);
  }
  .attest-tag{
    display: flex;
    align-items: center;
    gap: 6px;
    color: white;
    background: #4D4D4D;
  }
}
</style>
